/**
 * baseCrud 导出插件
 * 提供全量数据导出功能，支持字典值自动转换
 */

import {findByvalue} from '@/util/util'

export default {
	name: 'baseCrudExportPlugin',

	// 插件安装方法
	install(mixins, option = {}) {
		// 扩展 data
		const originalData = mixins.data
		mixins.data = function () {
			const data = originalData.call(this)
			return {
				...data,
			}
		}

		// 扩展 created 生命周期
		const originalCreated = mixins.created
		mixins.created = function () {
			originalCreated.call(this)
			this.$nextTick(() => {
				console.log('bbb', this.exportAllBtn)
				if (this.exportAllBtn) {
					this.addDownloadAllBtn()
				}
			})
		}

		// 扩展 methods
		Object.assign(mixins.methods, {
			//添加下载全部按钮
			addDownloadAllBtn() {
				let crudDom = this.$refs.crud_content ? this.$refs.crud_content.$el : this.$refs.crud.$el
				//添加在刷新按钮前面
				let refreshBtn = crudDom.querySelector('.avue-crud__right .avue-crud__refreshBtn')
				if (refreshBtn) {
					let newBtn = document.createElement('button')
					newBtn.innerHTML = '<i class="el-icon-download el-icon-download-all"></i>'
					newBtn.className = 'el-button el-button--default el-button--mini is-circle avue-crud__excelBtn'
					// 添加点击事件监听
					newBtn.addEventListener('click', () => {
						this.downloadAllData()
					})
					refreshBtn.parentNode.insertBefore(newBtn, refreshBtn)
				}
			},

			//下载全部数据
			async downloadAllData() {
				let loading = null
				try {
					// 显示加载状态
					loading = this.$loading({
						lock: true,
						text: '正在获取数据，请稍候...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)',
					})

					// 保存当前分页信息
					const originalPage = {...this.page}

					// 设置大页面大小获取全部数据
					const maxPageSize = this.page.total > 0 ? this.page.total : 100000
					this.page.currentPage = 1
					this.page.pageSize = maxPageSize

					// 使用现有的请求方法获取全部数据
					const requestData = this.getListReqData()

					// 发起请求获取全部数据
					const response = await this.api[option.apiNameList[parseInt(this.currentIndex)]](requestData)

					// 恢复原来的分页设置
					this.page = originalPage

					if (!response || !response.data) {
						throw new Error('响应数据格式错误')
					}

					// 使用现有的数据处理逻辑
					let {data} = response.data
					let request = option.apiNameList[parseInt(this.currentIndex)]
					let allData = []

					if (
						request === 'getSettlementOrdersBasic' ||
						request === 'getSettleApplyDetail' ||
						request === 'getSettleApplyDetailAward'
					) {
						// 处理钱，没有分页
						allData = [...data]
						this.dealFontMoney(allData, request)
					} else if (request === 'getNoApplyList' || request === 'getSettleApplyDetailPage') {
						allData = data['records'] || []
						this.dealFontMoney(allData, request)
					} else if (request === 'getSettlementOrdersAward' || request === 'getSettleApplyDetailAward') {
						// 奖励结算申请
						allData = [...data]
						this.dealAwardFontMoney(allData)
					} else if (request === 'getAwardList') {
						allData = data['records'] || []
						this.dealAwardFontMoney(allData, false)
					} else {
						// 标准分页数据
						allData = data['records'] || []
					}

					if (!allData || allData.length === 0) {
						this.$message.warning('暂无数据可导出')
						loading.close()
						return
					}

					allData = this.formaterListData(allData)
					// 生成导出标题（当前时间）
					const title = `${new Date().toLocaleDateString()}`

					// 过滤导出列（排除不需要的字段）
					const exportColumns = this.currentOption.column.filter((item) => item.prop !== 'validityPeriod' && !item.hide)

					// 处理导出数据 - 包括字典值转换
					const exportData = this.processExportData(allData, exportColumns)

					// 执行导出
					this.$Export.excel({
						title: title,
						columns: exportColumns,
						data: exportData,
					})

					loading.close()
					this.$message.success(`成功导出 ${allData.length} 条数据`)
				} catch (error) {
					console.error('导出数据失败:', error)
					this.$message.error('导出数据失败，请重试')
					if (loading) {
						loading.close()
					}
				}
			},

			//处理导出数据 - 转换字典值
			processExportData(allData, exportColumns) {
				// 处理每行数据
				return allData.map((item) => {
					const processedItem = {...item}

					// 遍历每个导出列，处理字典值转换
					exportColumns.forEach((column) => {
						let {prop, bind} = column
						if (prop && processedItem.hasOwnProperty(prop)) {
							const originalValue = processedItem[prop]
							const convertedValue = this.convertDictValue(column, originalValue)
							if (convertedValue !== originalValue) {
								processedItem[prop] = convertedValue
							}
						}
						// 处理bind属性，支持多级属性访问(如 channel.name)
						if (bind) {
							// 将bind字符串按.分割成数组
							const bindKeys = bind.split('.')
							// 从processedItem开始逐层获取值
							let bindValue = bindKeys.reduce((obj, key) => obj && obj[key], processedItem)
							// 如果成功获取到值，则更新到processedItem中
							processedItem[prop] = bindValue || ''
						}
					})
					return processedItem
				})
			},

			//转换字典值
			convertDictValue(column, value) {
				// 如果没有字典配置，直接返回原值
				if (!column.dicData && !column.dicUrl) {
					return value
				}

				// 使用 findObject 匹配对应 column 的 dicData
				const targetColumn = this.findObject(this.currentOption.column, column.prop)
				let dicData = targetColumn ? targetColumn.dicData : column.dicData

				if (!Array.isArray(dicData) || dicData.length === 0) {
					return value
				}

				// 获取字典项的属性配置
				const props = column.props || {label: 'label', value: 'value'}
				const labelProp = props.label
				const valueProp = props.value

				// 转换字典数据格式以适配 findByvalue 函数
				const formattedDicData = dicData.map((item) => ({
					label: item[labelProp] || item.label || item.name,
					value: item[valueProp] || item.value || item.id,
				}))

				// 使用 findByvalue 工具函数进行转换
				return findByvalue(formattedDicData, value)
			},
		})
	},
}
